import { Color } from '../commun/Constant';

export interface ISeparatorProps {}

export const Separator: React.FC<ISeparatorProps> = (props) => {
    return <div className="h-px w-full bg-slate-500 dark:bg-slate-400"></div>;
};
